import * as Contentful from 'contentful'

export enum ComponentLinkTargetTab {
  Self = 'Current ( _self )',
  Blank = 'New ( _blank )',
}

export enum ComponentLinkRelType {
  Canonical = 'canonical',
  External = 'external',
  NoFollow = 'nofollow',
  NoOpener = 'noopener',
  NoReferrer = 'noreferrer',
}

export enum ColorStyleType {
  Default = 'Default',
  Black = 'Black',
}

export interface TypeComponentLinkFields {
  internalName: Contentful.EntryFields.Symbol
  targetUrl: Contentful.EntryFields.Text
  title?: Contentful.EntryFields.Symbol
  targetTab?: Contentful.EntryFields.Symbol
  relationToUrl?: Contentful.EntryFields.Symbol[]
  appendCurrentQueryParams?: boolean
  showArrow?: boolean
  colorStyle?: ColorStyleType
  embeddedEntryText?: Contentful.EntryFields.Symbol
}

export type TypeComponentLink = Contentful.Entry<TypeComponentLinkFields>
